const AVATAR_COLORS = [
  '#3b82f6', // blue-500
  '#22c55e', // green-500
  '#a855f7', // purple-500
  '#f97316', // orange-500
  '#ec4899', // pink-500
  '#06b6d4', // cyan-500
  '#f59e0b', // amber-500
  '#6366f1', // indigo-500
]

const GUEST_ADJECTIVES = [
  'Quick',
  'Quiet',
  'Brave',
  'Calm',
  'Clever',
  'Curious',
  'Gentle',
  'Happy',
  'Lucky',
  'Bright',
  'Bold',
  'Witty',
  'Swift',
  'Mellow',
  'Sunny',
  'Eager',
]

const GUEST_ANIMALS = [
  'Otter',
  'Falcon',
  'Tiger',
  'Panda',
  'Fox',
  'Wolf',
  'Hawk',
  'Bear',
  'Owl',
  'Lynx',
  'Heron',
  'Badger',
  'Raven',
  'Moose',
  'Seal',
  'Hare',
]

function hashString(id: string): number {
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash)
  }
  return Math.abs(hash)
}

export function getUserColor(id: string): string {
  return AVATAR_COLORS[hashString(id) % AVATAR_COLORS.length]
}

// deterministic "<Adjective> <Animal>" so the same guest id always
// renders with the same name across reloads within a session.
export function getGuestName(id: string): string {
  const h = hashString(id)
  const adjective = GUEST_ADJECTIVES[h % GUEST_ADJECTIVES.length]
  const animal =
    GUEST_ANIMALS[
      Math.floor(h / GUEST_ADJECTIVES.length) % GUEST_ANIMALS.length
    ]
  return `${adjective} ${animal}`
}
